/// <amd-module name="VSSUI/Components/Dropdown/DropdownExpandableButton" />
import * as React from "react";
import { ExpandableButton } from "VSSUI/Button";
import { IDropdownExpandableButtonProps } from "./DropdownExpandable.Props";

export function DropdownExpandableButton(props: IDropdownExpandableButtonProps) {
    const { expandableRef, items, placeholder, renderSelectedItems, selection, tooltipProps, ...rest } = props;
    let text: JSX.Element | string | undefined = placeholder;
    if (selection.selectedCount > 0) {
        text = renderSelectedItems(selection, items);
    }
    return (
        <ExpandableButton
            ref={expandableRef as React.RefObject<ExpandableButton>}
            {...rest}
            tooltipProps={{ overflowOnly: true, overflowDetected, ...props.tooltipProps }}
        >
            <div className="bolt-dropdown-expandable-button-label justify-start flex-grow text-ellipsis">
                {props.children}
                {text}
            </div>
        </ExpandableButton>
    );
}

function overflowDetected(anchorElement: HTMLElement): boolean {
    const overflowElement = anchorElement.querySelector<HTMLElement>(".bolt-dropdown-expandable-button-label");
    if (overflowElement) {
        return overflowElement.scrollWidth > Math.ceil(overflowElement.offsetWidth);
    }
    return false;
}
